<script>
  import { afterUpdate, onMount, setContext } from 'svelte';

  import { LocalStorage } from '@client/utils/local-storage';

  import { createStyle } from './createStyle';
  import { setTheme } from './hooks';
  import { currentThemeName, currentThemeObject, themes as themesStore } from './theme.store';

  export let key = 'theme';
  export let themes = {};
  export let theme = null;
  export let base = {};

  themesStore.set(themes);

  $: currentThemeObject.set(themes[$currentThemeName]);

  const cssVariables = createStyle(base, theme);
  const savedTheme = LocalStorage.get(key);

  if (savedTheme === undefined) {
    LocalStorage.create(key, theme);
  }

  setContext('theme', {
    current: currentThemeName,
    setTheme
  });

  onMount(() => {
    if (theme && themes[theme]) {
      currentThemeName.set(theme);
    } else if (savedTheme && themes[savedTheme]) {
      currentThemeName.set(savedTheme);
    } else {
      currentThemeName.set('galapagos');
    }

    return () => LocalStorage.update(key, $currentThemeName);
  });

  // Theme wraps the whole app, so afterUpdate fires on every parent state change. Only
  // act on an actual theme change: the write serialises the entire store synchronously.
  let appliedTheme = null;

  afterUpdate(() => {
    if ($currentThemeName === appliedTheme) {
      return;
    }

    appliedTheme = $currentThemeName;

    if (document) {
      document.documentElement.setAttribute('theme', $currentThemeName);
    }

    LocalStorage.update(key, $currentThemeName);
  });
</script>

<svelte:head>
  {@html cssVariables}
</svelte:head>

<slot />
